<div fxFlexFill fxLayoutAlign="center center" fxFill style="line-height: 150px;">  
    <div  fxFlex.gt-xs="500px" fxFlex.gt-sm="800px" fxFlex.gt-md="1000px" fxFlex.gt-lg="1140px">
        <mat-divider></mat-divider>  
        {{'all-right-reserved' | translate: {year: year} }}
    </div>
</div>

